import React, { useEffect, useState } from 'react';
import { isArray, isEmpty, last } from 'lodash-es';
import SingleQA from '@/pages/aigc/pages/Agent/ChatPage/components/SingleQA';
import CopilotAnswerLoading from '../AnswerLoading';
import { MemoizedCopilotSortCompChild } from './components';
import { Conversation } from '@/pages/aigc/pages/Agent/ChatPage/types/history';
import ChartShareModal from '@/pages/aigc/pages/Agent/ChatShare/ChatShareModal';
import { ChatShareDialog } from '@/pages/aigc/pages/Agent/ChatShare/types/chatShare';
import { ChartDSTempImg } from '../../../ChatShare/components/ChartDSTempImg';
import classNames from 'classnames';
import type { TPageHandleSubmit } from '@/pages/aigc/pages/Agent/components/QAInput';

interface CopilotSingleQAProps {
  conversations: Conversation[];
  streamingState: string;
  userInfo: {
    username?: string;
  };
  errorTipsMessage?: (type: string) => string;
  setHaveEdit?: (value: boolean) => void;
  /** 页面层消息提交，对象入参 */
  handleSubmit: TPageHandleSubmit;
  handleLikeOrDislike: (messageId: string, like: number) => void;
  isProcessing: boolean;
  voiceActiveBar?: number;
  style?: object;
  /** DS 报告模板信息 */
  dsReportName?: {
    agent_title?: string;
    agent_banner?: string;
  };
  /** 文件卡片点击回调 - 用于打开 DS 报告窗口 */
  onFileCardClick?: (dsReportData: any) => void;
  onRecommendClick?: (value: string, isWebSearch?: boolean) => void;
}

export const CopilotSingleQA = ({
  conversations,
  streamingState,
  userInfo,
  errorTipsMessage,
  setHaveEdit,
  handleSubmit,
  isProcessing,
  voiceActiveBar,
  style,
  handleLikeOrDislike,
  dsReportName,
  onFileCardClick,
  onRecommendClick,
}: CopilotSingleQAProps) => {
  const [editObj, setEditObj] = useState({});
  const [showShareChatDialog, setShowShareChatDialog] = useState<ChatShareDialog>();
  const [aboveFromCopilotZIndex, setAboveFromCopilotZIndex] = useState(1001);

  useEffect(() => {
    const copilotDOM = document.getElementsByClassName('dbh-agent-copilot')?.[0];
    if (copilotDOM) {
      const copilotZIndex = window.getComputedStyle(copilotDOM).zIndex;
      setAboveFromCopilotZIndex(copilotZIndex ? parseInt(copilotZIndex, 10) + 5 : 1001);
    }
  }, []);

  return (
    <div className="dba-chat-scroll">
      {
        showShareChatDialog?.isShowCopyDialog &&
        <ChartShareModal
          showShareChatDialog={showShareChatDialog}
          setShowShareChatDialog={setShowShareChatDialog}
          style={{ zIndex: aboveFromCopilotZIndex }}
        />
      }

      <div className="dba-chat-content">
        {!isEmpty(conversations) && <ChartDSTempImg {...{
          title: dsReportName?.agent_title as string,
          img: dsReportName?.agent_banner as string,
          className: classNames({
            'dba-chat-content-ds-template': !!dsReportName?.agent_title,
            'dba-chat-content-ds-template-list': !!dsReportName?.agent_title
          })
        }} />}
        {isArray(conversations) &&
          conversations?.map((conversation) => {
            const isLastItem =
              last(conversations)?.messageId === conversation?.messageId;
            const fileData = conversation?.fileData;
            const fileListResult =
              fileData?.length > 0 ? fileData : conversation?.frontFileList;
            const fileListData = {
              [conversation?.messageId]: fileListResult,
            };

            return (
              <SingleQA
                {...{ ...conversation, conversations }}
                key={conversation.messageId}
                question={conversation.query}
                streamingState={streamingState}
                isLastQA={isLastItem}
                onRecommendClick={onRecommendClick}
                userInfo={{ ...userInfo, username: '' }}
                editObj={editObj}
                setEditObj={setEditObj}
                setHaveEdit={setHaveEdit}
                handleSubmit={handleSubmit}
                errorTipsMessage={errorTipsMessage}
                isProcessing={isProcessing}
                fileList={fileListData}
                AnswerLoading={CopilotAnswerLoading}
                contentSingleQA={(props: any) => <MemoizedCopilotSortCompChild {...props} />}
                voiceActiveBar={voiceActiveBar}
                style={style}
                setShowShareChatDialog={setShowShareChatDialog}
                handleLikeOrDislike={handleLikeOrDislike}
                from='copilot'
                handleUpdateDsReport={onFileCardClick}
              />
            );
          })}
      </div>
    </div>
  );
};
